import React from 'react';

const SpinButton = ({ whenClicked, classNames, inputType, showSpinner, spinText, buttonText, ...rest }) =>
    (
        <button
            onClick   = {whenClicked}
            className = {`${classNames}`}
            type      = {inputType ? inputType : "button"}
            disabled  = {showSpinner}
            {...rest}
        >
            {
                showSpinner
                    ? <i className = "fa fa-spinner fa-pulse"></i>
                    : null
            }
            {
                showSpinner
                    ? ` ${spinText}`
                    : buttonText
            }
        </button>
    );

SpinButton.propTypes = {
    whenClicked : React.PropTypes.func,
    classNames  : React.PropTypes.string.isRequired,
    showSpinner : React.PropTypes.bool.isRequired,
    spinText    : React.PropTypes.string.isRequired,
    buttonText  : React.PropTypes.string.isRequired
};

export default SpinButton;




// WEBPACK FOOTER //
// src/components/generic/spin-button.js